/**
 * Bokningsgäster (profiles_v2.user_type = 'guest') skapas av bokningsflödet
 * enbart för att en bokning och dess nyckel behöver en ägare. De är inte
 * medlemmar i någon organisation och ska aldrig hamna i Åtkomst-appen —
 * nyckeln visas på bokningsappens inloggningsfria nyckelsida.
 *
 * Detta är en UX-spärr: RLS (guests_own_bookings_only) och det borttagna
 * org-medlemskapet är säkerhetsgränsen på serversidan.
 */
export function isBookingGuestProfile(
  profile: { user_type?: string | null } | null | undefined,
): boolean {
  return profile?.user_type === 'guest';
}
